import React, { ReactNode } from 'react'
import PhoneInput from "react-phone-input-2";

interface IInput {
    changeHandler: (data: any) => any,
    blurHandler?: (data: any) => any,
    value: string,
    placeholder?: string,
    disabled?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType<{}>
    validationError?: boolean,
    validationErrorDescription?: string,
    require?: boolean,
    id?: string,
}

const Input: React.FC<IInput> = (
    {
        changeHandler,
        placeholder,
        disabled = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        validationError,
        validationErrorDescription,
        value,
        blurHandler,
        require = true,
    }
) => {

    // @ts-ignore
    return (
        <>
            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <>
                        <label
                            className={`block text-gray-600 text-left font-medium mb-1 ${customLabelClassName ? customLabelClassName : ""}`}
                            htmlFor={name}
                        >
                            {label}
                            {require && <span className="text-red-500 px-1">*</span>}
                        </label>
                    </>
                )
            }
            <PhoneInput
                inputStyle={{ outline: "none", border: "1px solid", borderColor: validationError ? "rgba(244, 63, 94, var(--tw-text-opacity))" : "rgba(226, 232, 240, var(--tw-border-opacity))", width: "100%", color: "#000000" }}
                buttonStyle={{ outline: "none", border: "1px solid", borderColor: validationError ? "rgba(244, 63, 94, var(--tw-text-opacity))" : "rgba(226, 232, 240, var(--tw-border-opacity))" }}
                regions={['north-america', 'europe']}
                country={"ru"}
                onBlur={blurHandler}
                preferredCountries={['ru', 'ua', 'by']}
                placeholder={placeholder || `+7 (999) 888-77-66`}
                value={value}
                prefix={"+"}
                onChange={(v, d, e) => {
                    e.target.value = v
                    if (v.replace(/\D/g, '').length === 2) {
                        e.target.value = v.replace('8', '')
                    }
                    changeHandler(e)
                }}
            />
            {
                validationErrorDescription && (
                    <div className="text-xs text-left text-red-500">
                        {validationErrorDescription}
                    </div>
                )
            }
        </>
    )
}

export default Input